import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'
import { getUserId, getUserName, isFetchSessionInProgress } from '../session/'
import { isSocketConnected } from '../connection/'
import { isMainMenuOpen, isUserMenuOpen, isCurrentBidsOpen } from './selectors'
import { toggleMainMenu, toggleUserMenu } from './actions'
import { logout } from '../session/'

function mapStateToProps(state) {
  return {
    isLoading: !isSocketConnected(state) || isFetchSessionInProgress(state),
    userId: getUserId(state),
    userName: getUserName(state),
    isMainMenuOpen: isMainMenuOpen(state),
    isUserMenuOpen: isUserMenuOpen(state),
    isCurrentBidsOpen: isCurrentBidsOpen(state)
  }
}

const mapDispatch = {
  toggleMainMenu,
  toggleUserMenu,
  logout
}

const withToggleMenuOrLogin = withProps(props => ({
  toggleUserMenu(e) {
    if (props.userId) {
      props.toggleUserMenu()
    } else {
      props.history.push('/login')
    }
  },
  onLogoutClick(e) {
    // prevent navigation
    e.preventDefault()
    props.logout()
    props.toggleUserMenu()
  }
}))

const withUserDataAndMenuActions = connect(mapStateToProps, mapDispatch)

export const enhance = compose(
  withUserDataAndMenuActions,
  withToggleMenuOrLogin
)

export default enhance



// WEBPACK FOOTER //
// ./src/services/layout/layout-context.js